import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Text, Stack, Button} from '@chakra-ui/react'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import {remCalc} from '../../../theme/_utils'

const NoOrdersAvailable = () => {
    const navigate = useNavigation()

    return (
        <Stack gap={remCalc(16)} alignItems="flex-start" data-testid="no-orders-available">
            <Text color="text.default" fontWeight="500" textStyle="head-medium">
                <FormattedMessage
                    id="account_order_history.heading.no_order_yet"
                    defaultMessage="You haven't placed an order yet."
                />
            </Text>
            <Text color="text.default" textStyle="body-medium">
                <FormattedMessage
                    id="account_order_history.description.once_you_place_order"
                    defaultMessage="Once you place an order the details will show up here."
                />
            </Text>
            <Button
                onClick={() => navigate('/')}
                variant="primary"
                width={{base: '100%', lg: remCalc(332)}}
            >
                <Text textStyle="body-medium">
                    <FormattedMessage
                        id="account_order_history.button.continue_shopping"
                        defaultMessage="Continue Shopping"
                    />
                </Text>
            </Button>
        </Stack>
    )
}

export default NoOrdersAvailable
